// extracted by mini-css-extract-plugin
export default {"title":"Contact_title__VJziC","subTitle":"Contact_subTitle__hCsrz","button":"Contact_button__skGon"};